import { render, staticRenderFns } from "./StudentRequirements.vue?vue&type=template&id=6749d7b8&scoped=true"
import script from "./StudentRequirements.vue?vue&type=script&lang=js"
export * from "./StudentRequirements.vue?vue&type=script&lang=js"
import style0 from "./StudentRequirements.vue?vue&type=style&index=0&id=6749d7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6749d7b8",
  null
  
)

export default component.exports